import { c as _c } from "react/compiler-runtime";
import { cn } from '@/lib/utils';
export interface StepperProps {
  canGoNext: boolean;
  canGoPrevious: boolean;
  children: React.ReactNode;
  className?: string;
  nextIcon: React.ReactNode;
  nextLabel: string;
  onNext: () => void;
  onPrevious: () => void;
  previousIcon: React.ReactNode;
  previousLabel: string;
}
const arrowClassName = 'inline-flex size-10 shrink-0 items-center justify-center text-foreground transition-colors hover:bg-accent focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset focus-visible:outline-none disabled:opacity-40 disabled:hover:bg-transparent';

/**
 * The design's stepper: one bordered segment holding a back arrow, the value
 * and a forward arrow, rather than three controls spaced apart.
 *
 * Purely presentational — what sits between the arrows is the caller's, so the
 * same frame serves a number being nudged and a value being cycled through.
 */
export const Stepper = t0 => {
  const $ = _c(19);
  const {
    canGoNext,
    canGoPrevious,
    children,
    className,
    nextIcon,
    nextLabel,
    onNext,
    onPrevious,
    previousIcon,
    previousLabel
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("inline-flex items-center overflow-hidden rounded-md border border-input bg-card", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !canGoPrevious;
  let t3;
  if ($[2] !== onPrevious || $[3] !== previousIcon || $[4] !== previousLabel || $[5] !== t2) {
    t3 = <button type="button" aria-label={previousLabel} className={arrowClassName} disabled={t2} onClick={onPrevious}>{previousIcon}</button>;
    $[2] = onPrevious;
    $[3] = previousIcon;
    $[4] = previousLabel;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children) {
    t4 = <div className="flex h-10 items-center justify-center border-x border-border">{children}</div>;
    $[7] = children;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = !canGoNext;
  let t6;
  if ($[9] !== nextIcon || $[10] !== nextLabel || $[11] !== onNext || $[12] !== t5) {
    t6 = <button type="button" aria-label={nextLabel} className={arrowClassName} disabled={t5} onClick={onNext}>{nextIcon}</button>;
    $[9] = nextIcon;
    $[10] = nextLabel;
    $[11] = onNext;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t1 || $[15] !== t3 || $[16] !== t4 || $[17] !== t6) {
    t7 = <div className={t1}>{t3}{t4}{t6}</div>;
    $[14] = t1;
    $[15] = t3;
    $[16] = t4;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};